import styled, { css } from 'styled-components';

interface IButtonsWrapperProps {
  buttonsAlignment: 'left' | 'center' | 'right';
}

export const CallToActionWrapper = styled.section<{ backgroundColor?: string }>`
  width: 100%;

  ${(props) =>
    props.backgroundColor &&
    css`
      background: ${props.theme.colors[props.backgroundColor as keyof typeof props.theme.colors]};
    `}
`;

export const Content = styled.div<{ backgroundColor?: string }>`
  max-width: 1200px;
  margin: 0 auto;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 500;
    letter-spacing: -0.02em;
    padding-bottom: 39px;
    margin: 0;
  }

  h1 {
    font-size: 3rem;
    line-height: 4.5rem;

    @media (max-width: 768px) {
      font-size: 2.125rem;
      line-height: 42px;
    }
  }

  h2 {
    font-size: 2.5rem;
    line-height: 3.5rem;

    @media (max-width: 768px) {
      font-size: 1.875rem;
      line-height: 36px;
    }
  }

  h3 {
    font-size: 2rem;
    line-height: 3rem;

    @media (max-width: 768px) {
      font-size: 1.5rem;
      line-height: 30px;
    }
  }

  h4 {
    font-size: 1.5rem;
    line-height: 2.25rem;

    @media (max-width: 768px) {
      font-size: 1.25rem;
      line-height: 26px;
    }
  }

  h5 {
    font-size: 1.25rem;
    line-height: 1.875rem;

    @media (max-width: 768px) {
      font-size: 1.125rem;
      line-height: 22px;
    }
  }

  h6 {
    font-size: 1.125rem;
    line-height: 1.75rem;

    @media (max-width: 768px) {
      font-size: 1rem;
      line-height: 20px;
    }
  }

  &&& {
    strong,
    a,
    b {
      color: ${(props) =>
        props.backgroundColor === 'lightGradient'
          ? props.theme.colors.darkText
          : props.theme.colors.white};
      font-weight: 600;
    }
  }

  p {
    font-style: normal;
    font-weight: 425;
    font-size: 1.125rem;
    line-height: 1.6875rem;
    margin: 0;
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${(props) =>
      props.backgroundColor === 'lightGradient'
        ? props.theme.colors.darkText
        : props.theme.colors.white};
  }
`;

export const ButtonsWrapper = styled.div<IButtonsWrapperProps>`
  display: flex;
  align-items: ${(props) => props.buttonsAlignment};
  justify-content: ${(props) => props.buttonsAlignment};
  width: 100%;

  margin-top: 54px;

  div {
    display: flex;
    gap: 16px;
    text-decoration: none;
  }

  a {
    text-decoration: none;
  }
`;
